import React from 'react';

import { ChipListInput } from 'components/ChipListInput/ChipListInput';

interface ISegmentsSectionProps {
  items: string[];
  onItemsChange: (items: string[]) => void;
  description?: string;
  placeholder?: string;
  inputTestId?: string;
  listTestId?: string;
}

export const SegmentsSection: React.FC<ISegmentsSectionProps> = ({
  items,
  onItemsChange,
  description = 'Create or add players segments to your offer',
  placeholder = 'Search Segment',
  inputTestId,
  listTestId
}): React.ReactElement => (
  <ChipListInput
    items={items}
    onItemsChange={onItemsChange}
    title="Segments"
    description={description}
    inputLabel="Segment Name"
    placeholder={placeholder}
    inputTestId={inputTestId}
    listTestId={listTestId}
  />
);
